import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJActionImageManipulation from '../../../../redux/action/FJActionImageManipulation.js';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon.js';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput.jsx';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJImageManipulationInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const disableUpload = useMemo(() => {
        return taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR;
    }, [taskStatus]);

    const uploadImg = file => {
        dispatch(FJActionImageManipulation.uploadImageAction(file));
    };

    const openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    return (
        <FJImageInput
            openMediaLibrary={openMediaLibrary}
            uploadImageInfo={uploadImageInfo}
            isDraggingFile={isDraggingFile}
            disableUpload={disableUpload}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            disable={taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
        />
    );
};
export default FJImageManipulationInputContainer;
